<template>
  <div class="mobile_only header-mobile">
    <div class="header-mobile_in relative flex flex--start">
      <div class="menu_bt z--1">
        <a
          class="flex flex--content--center"
          href="#menu"
          @click.prevent="TOGGLE_MENU"
        >
          <span class="hamburger"><span class="menu_bt_sep"></span></span>
        </a>
      </div>
      <div id="pageTitle" class="title">
        {{ pageTitle }}
      </div>
      <div v-if="$route.name == 'profile'" class="myMedical-logo">
        <img src="assets/img/svg/shape-myMedical.svg" />
      </div>

      <!-- messages btn -->
      <router-link
        to="/contact"
        v-show="$route.name == 'messages'"
        class="mm-send"
      >
        <img src="/assets/img/svg/mm-send.svg" />
      </router-link>

      <!-- search btn -->
      <a
        v-show="!hideSearchRoutes.includes($route.name)"
        class="bt_search flex m-flex--center"
        :style="$route.name == 'surg-app-list' ? 'left: 15px;' : ''"
        href="javascript:void(0);"
        @click="openSearch"
      >
        <SearchSvg />
      </a>
      <div class="mobile_search_open bg--blue-light">
        <div class="mobile_search relative">
          <form @submit.prevent="searchById" autocomplete="off">
            <input
              class="mobile_search_input"
              type="text"
              v-model="id"
              :placeholder="'חיפוש ' + searchPlaceholder"
              autocomplete="off"
              v-on:keypress="numbersOnly"
            />
            <span class="error-message err-msg-search" v-if="errMsg">{{
              errMsg
            }}</span>
            <input class="mobile_search_submit" type="submit" value="" />
          </form>
        </div>
        <a
          class="close_search flex flex--content--center"
          href="javascript:void(0);"
          @click="closeSearch"
        >
          <ArrowBack />
        </a>
      </div>

      <!-- plus btn -->
      <div v-click-outside="hideSelect">
        <div
          href="javascript:void(0)"
          @click.prevent="goTo"
          class="bt_blue flex m-flex--center"
          v-show="!showPlusBtn.includes($route.name)"
        >
          <span class="plus"></span>
        </div>
        <div class="surg-select" v-if="showSurgeryMenu">
          <router-link :to="{ name: 'surg-add' }"
            >יצירת ניתוח לשיבוץ</router-link
          >
          <router-link :to="{ name: 'surg-add-block' }">
            הזמנת בלוק ניתוחים
          </router-link>
        </div>
        <div class="surg-select" v-if="showAppMenu">
          <router-link :to="{ name: 'app-add' }">יצירת תור</router-link>
          <router-link :to="{ name: 'add-block' }">
            יצירת בלוק
          </router-link>
        </div>
      </div>
    </div>

    <!-- search results -->
    <div class="results_box tx--black" v-if="showSearch">
      <div class="filter-booking-mobile flex flex--start">
        <div class="filter-booking-title flex flex--start">
          <img src="/assets/img/svg/filters-icon.svg" />
          חיפוש לפי:
        </div>
        <div class="filter-booking-tabs flex flex--start">
          <div class="form_check form_radio desk-no-marge">
            <label class="form_check_tx">
              ת.ז
              <input
                type="radio"
                name="edit_all_blocks"
                v-model="searchType"
                value="by_passport"
              /><span class="checkmark"></span>
            </label>
          </div>
          <div class="form_check form_radio desk-no-marge">
            <label class="form_check_tx">
              טלפון נייד
              <input
                type="radio"
                name="edit_all_blocks"
                v-model="searchType"
                value="by_phone"
              /><span class="checkmark"></span>
            </label>
          </div>
          <div class="form_check form_radio desk-no-marge">
            <label class="form_check_tx">
              שם
              <input
                type="radio"
                name="edit_all_blocks"
                v-model="searchType"
                value="by_name"
              /><span class="checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      <div v-if="showSearchRes || showSearchLoader">
        <div class="center results_box_title" v-if="searchResults.length > 0">
          {{ searchResults.length }} תורים נמצאו עבור {{ query_id }} עבור רופא
          {{ selectedDocName }}
        </div>
        <div
          class="center results_box_title"
          v-if="searchResults.length == 0 && !showSearchLoader"
        >
          לא אותרו מטופלים לרופא
        </div>
        <div class="center results_loader" v-if="showSearchLoader">
          <div>אנא המתן לטעינת תוצאות...</div>
          <vue-loaders-ball-clip-rotate
            color="black"
            scale="1.2"
          ></vue-loaders-ball-clip-rotate>
        </div>
        <a
          class="results_box_row block"
          v-for="(row, index) in searchResults"
          :key="index"
          @click="onApp(row.appointment_id, row.appType)"
        >
          <span class="results_date block">
            {{ row.date + " - " + row.appType
            }}{{ row.status == "בוטל" ? ", " : "" }}
            <span v-if="row.status == 'בוטל'"><b>בוטל</b></span>
          </span>
          <div class="results_tx block">
            <b>{{ row.time }}</b>
            {{ row.name }} | {{ row.id }} | {{ row.phone }} |
            {{ row.insurance }}
            <span v-if="row.note" class="note block"> {{ row.note }}</span>
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import SearchSvg from "../../assets/img/svg/search.svg";
import ArrowBack from "../../assets/img/svg/arrow_back.svg";
import DocSelect from "@/components/Popups/SearchDocSelect";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Error from "@/components/Popups/Error";
import ClickOutside from "vue-click-outside";
import { getHash } from "../../utilities/hash.js";
import { iframeConfigs } from "../../utilities/iframe-cellosign-config.js";

export default {
  name: "Header",
  data() {
    return {
      id: "",
      allResults: [],
      showSearch: false,
      showSearchRes: false,
      query_id: "",
      showSearchLoader: false,
      selected_doctor: "",
      selected_doc_name: "",
      showSurgeryMenu: false,
      showAppMenu: false,
      searchType: "by_passport",
      errMsg: "",
      hideSearchRoutes: ["messages", "cellosign", "cellosign-iframe"],
      showPlusBtn: [
        "contact",
        "license-plate",
        "calendar",
        "summery-page",
        "lobby",
        "surg-app-list",
        "profile",
        "messages",
        "cellosign",
        "cellosign-iframe"
      ]
    };
  },
  watch: {
    $route(to, from) {
      if (to.fullPath != from.fullPath) {
        this.showSurgeryMenu = false;
      }
    },
    searchType(val) {
      this.id = "";
      this.showSearchLoader = false;
      this.query_id = this.id;
      this.allResults = [];
      this.showSearchRes = false;
      this.showSearchLoader = false;
    }
  },
  mounted() {
    if (this.hashData && this.hashData.searchQuery) {
      this.searchType = this.hashData.searchType;
      setTimeout(() => {
        this.id = decodeURIComponent(this.hashData.searchQuery);
      }, 20);
      setTimeout(() => {
        this.searchById();
        this.openSearch();
      }, 50);
    }
    this.$root.$on("selected-doctor", event => {
      this.selected_doctor = event.doc;
    });
  },
  computed: {
    ...mapGetters(["activeDoctor", "doctors"]),
    searchResults() {
      const filtered = this.allResults.filter(
        res => res.doctor_id == this.selected_doctor
      );
      const sortedByTime = filtered.sort((a, b) => {
        let aa = a.time.substring(0, 4);
        let bb = b.time.substring(0, 4);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
      });
      return sortedByTime.sort((a, b) => {
        let aa = a.date
          .split("/")
          .reverse()
          .join();
        let bb = b.date
          .split("/")
          .reverse()
          .join();
        return aa < bb ? -1 : aa > bb ? 1 : 0;
      });
    },
    selectedDocName() {
      return this.doctors.find(d => d.id == this.selected_doctor).name || "";
    },
    pageTitle() {
      switch (this.$route.name) {
        case "Dashboard":
          return `יומן ${this.activeDoctor.name ? this.activeDoctor.name : ""}`;
        case "clinic":
          return "מרפאה";
        case "above":
        case "calendar":
          return "מבט על";
        case "list":
          return "רשימת תורים";
        case "surgeries-list":
          return "רשימת ניתוחים";
        case "surgeries":
          return "ניתוחים";
        case "contact":
          return "צור קשר עם בית החולים";
        case "license-plate":
          return "בקשה להוספה/החלפת רכב בחניון רופאים";
        case "surg-app-list":
          return "רשימת מטופלים";
        case "cellosign-iframe": {
          const cfg = iframeConfigs[this.$route.params.type];
          return cfg ? cfg.title : "";
        }
        case "messages":
          return "ההודעות שלי";
        case "cellosign":
          return "טפסי הסכמה";
        default:
          return "";
      }
    },
    searchPlaceholder() {
      switch (this.searchType) {
        case "by_passport":
          return "ת.ז";
        case "by_phone":
          return "טלפון נייד";
        case "by_name":
          return "שם";
        default:
          return "";
      }
    }
  },
  methods: {
    ...mapActions(["TOGGLE_MENU"]),
    ...mapMutations(["SET_SHOW_SEARCH"]),
    numbersOnly(ev) {
      if (this.searchType == "by_name") return true;
      ev = ev ? ev : window.event;
      var charCode = ev.which ? ev.which : ev.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        ev.preventDefault();
      } else {
        return true;
      }
    },
    hideSelect() {
      if (this.showSurgeryMenu) this.showSurgeryMenu = false;
    },
    async onApp(id, type) {
      await this.SET_SHOW_SEARCH(false);
      if (type == "ניתוח") this.$router.push("/surg-info/" + id);
      else this.$router.push("/app-info/" + id);
    },
    goTo() {
      if (this.$route.name == "surgeries") {
        this.showSurgeryMenu = !this.showSurgeryMenu;
      }
      if (this.$route.name == "Dashboard") {
        this.showAppMenu = !this.showAppMenu;
      }
      if (this.$route.name == "calendar") {
        this.$router.push({ name: "app-add" });
      }
      if (this.$route.name == "list") {
        this.$router.push({ name: "app-add" });
      }
      return;
    },
    openSearch() {
      let searchElement = document.getElementsByClassName(
        "mobile_search_open"
      )[0];
      searchElement.classList.add("open");
      searchElement.focus();
      this.showSearch = true;
    },
    closeSearch() {
      let searchElement = document.getElementsByClassName(
        "mobile_search_open"
      )[0];
      searchElement.classList.remove("open");
      this.showSearch = false;
      this.SET_SHOW_SEARCH(false);
      this.allResults = [];
      this.showSearchLoader = false;
      this.showSearchRes = false;
      this.id = "";
      this.searchType = "by_passport";
      this.$API.cancelAjaxRequest();
      window.location.hash = getHash({ searchQuery: "", searchType: "" });
    },
    async searchById() {
      this.errMsg = "";
      this.allResults = [];
      let docs = [];
      this.showSearchRes = false;
      if (!this.id) {
        this.errMsg = "שדה חובה";
        return;
      }
      this.showSearchLoader = true;
      this.query_id = this.id;
      this.$API
        .searchAppointments(
          this.activeDoctor.id,
          this.query_id,
          this.searchType
        )
        .then(res => {
          this.showSearchLoader = false;
          this.showSearchRes = true;
          this.SET_SHOW_SEARCH(true);
          res.data.map(row => {
            if (row) {
              let temp = {
                appType: row.DT_RowId.includes("surgery") ? "ניתוח" : "תור",
                // id: row.patient_information.passport,
                id: row.real_patient.passport,
                // appointment_id: row.appointment_info.appointment_id,
                appointment_id: row.DT_RowId.includes("surgery")
                  ? row.time.surgery_id
                  : row.time.appointment_id,
                // doctor_id: row.appointment_doctor.doctor_id,
                doctor_id: row.doctor.doctor_id,
                // date: row.appointment_date.start_date,
                date: this.$moment(row.date.date, "YYYY/MM/DD").format(
                  "DD/MM/YYYY"
                ),
                // phone: row.patient_information.phone,
                phone: row.phone.phone,
                // name:
                //   row.patient_information.first_name +
                //   " " +
                //   row.patient_information.last_name,
                name:
                  row.real_patient.first_name +
                  " " +
                  row.real_patient.last_name,
                // time: row.appointment_time.time,
                time: row.time.time,
                // insurance: row.appointment_insurance.insurance_name,
                insurance: row.insurance.insurance_name,
                // status: row.status,
                status: row.status.status,
                note: row.notes.note
              };
              // Doctors
              const findDoc = docs.find(
                d => d.doctor_id == row.doctor.doctor_id
              );
              if (!findDoc) docs.push(row.doctor);
              // All res
              this.allResults.push(temp);
            }
          });
          if (docs && docs.length > 1) {
            this.$modal.show(DocSelect, { id: this.query_id, docs: docs });
          } else if (docs && docs.length) {
            this.selected_doctor = docs[0].doctor_id;
            window.location.hash = getHash({
              searchQuery: this.query_id,
              searchType: this.searchType
            });
          }
        })
        .catch(e => {
          this.$modal.show(Error);
        });
    }
  },
  components: {
    SearchSvg,
    ArrowBack
  },
  directives: {
    ClickOutside
  }
};
</script>

<style scoped>
.header-mobile {
  z-index: 100;
}
.results_box {
  min-height: 100vh;
  overflow: auto;
}
.results_loader {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.surg-select a {
  display: block;
  background: #fff;
  padding: 2px 10px;
}
.surg-select {
  position: absolute;
  left: 0;
  top: 53px;
}

.err-msg-search {
  position: absolute;
  top: 18px;
  left: 30px;
  color: #efefea;
}
</style>
